module.exports = __webpack_public_path__ + "img/loading.5c232c34.svg";